import React, { useState } from 'react';
import { sendBroadcastSMS } from '../../services/essieService';
import './BroadcastSMS.css';

const BroadcastSMS = () => {
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const maxLength = 160;
  const remainingChars = maxLength - message.length;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!message.trim()) {
      setError('Le message est obligatoire');
      return;
    }

    if (message.length > maxLength) {
      setError(`Le message ne doit pas dépasser ${maxLength} caractères`);
      return;
    }

    try {
      setLoading(true);
      setError('');
      setResult(null);

      const response = await sendBroadcastSMS(message);
      setResult(response);
      setMessage(''); // Réinitialiser le message après envoi réussi
    } catch (err) {
      console.error('Erreur lors de l\'envoi:', err);
      setError(err.response?.data?.error || 'Erreur lors de l\'envoi des SMS');
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setMessage('');
    setResult(null);
    setError('');
  };

  return (
    <div className="broadcast-sms-container">
      <div className="broadcast-sms-header">
        <h2>Envoi de SMS Groupé</h2>
        <p className="subtitle">Envoyer un message à tous les adhérents principaux actifs</p>
      </div>

      <form onSubmit={handleSubmit} className="broadcast-sms-form">
        <div className="form-group">
          <label htmlFor="message">Message SMS</label>
          <textarea
            id="message"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="ESSIE-EHOUN: Votre message ici..."
            rows="5"
            disabled={loading}
            className={remainingChars < 0 ? 'error' : ''}
          />
          <div className="char-counter">
            <span className={remainingChars < 0 ? 'error' : remainingChars < 20 ? 'warning' : ''}>
              {remainingChars} caractères restants
            </span>
            <span className="total">({message.length}/{maxLength})</span>
          </div>
        </div>

        {error && (
          <div className="alert alert-error">
            <i className="icon-error">⚠️</i>
            <span>{error}</span>
          </div>
        )}

        <div className="form-actions">
          <button
            type="button"
            onClick={handleReset}
            className="btn btn-secondary"
            disabled={loading || (!message && !result)}
          >
            Réinitialiser
          </button>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading || !message.trim() || remainingChars < 0}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                Envoi en cours...
              </>
            ) : (
              <>
                <i className="icon-send">📤</i>
                Envoyer à tous les adhérents
              </>
            )}
          </button>
        </div>
      </form>

      {result && (
        <div className="broadcast-result">
          <div className="alert alert-success">
            <i className="icon-success">✅</i>
            <span>{result.message}</span>
          </div>

          <div className="result-summary">
            <h3>Résumé de l'envoi</h3>
            <div className="summary-stats">
              <div className="stat-card total">
                <div className="stat-value">{result.summary.total}</div>
                <div className="stat-label">Total</div>
              </div>
              <div className="stat-card success">
                <div className="stat-value">{result.summary.success}</div>
                <div className="stat-label">Réussis</div>
              </div>
              <div className="stat-card failed">
                <div className="stat-value">{result.summary.failed}</div>
                <div className="stat-label">Échoués</div>
              </div>
            </div>

            {result.testMode && (
              <div className="test-mode-badge">
                <i>🧪</i> Mode Test Activé
              </div>
            )}
          </div>

          <div className="result-details">
            <h3>Détails des envois</h3>
            <div className="details-table-container">
              <table className="details-table">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Nom</th>
                    <th>Téléphone</th>
                    <th>Statut</th>
                    <th>Provider</th>
                  </tr>
                </thead>
                <tbody>
                  {result.results.map((r, index) => (
                    <tr key={index} className={r.success ? 'success-row' : 'error-row'}>
                      <td>{r.adherentCode}</td>
                      <td>{r.adherentNom}</td>
                      <td>{r.phoneNumber}</td>
                      <td>
                        {r.success ? (
                          <span className="status-badge success">✓ Envoyé</span>
                        ) : (
                          <span className="status-badge error">✗ Échec</span>
                        )}
                      </td>
                      <td>
                        <span className="provider-badge">{r.provider}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BroadcastSMS;
